import React, {  useState } from 'react'

const ModalConsultarProcedimientosNoOperacionales = ({setmodalOnConsultarProcedimientosNoOperacionales,dataUnProcedimientoNoOperacional}) => { 
          const handleCancelarClick=()=>{
                setmodalOnConsultarProcedimientosNoOperacionales(false)
          }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
       <div className="sm:h-[calc(100%)] max-w-7xl   mx-auto relative w-auto pointer-events-none ">
        <div className=" max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#437cdc]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Consultar Procedimientos No Operacionales
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative px-2">
            <form >
              <div className="flex py-2 text-left">
                <div className="w-1/3">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código
                  </label>
                  <input                     
                    disabled={true}  
                    defaultValue={dataUnProcedimientoNoOperacional.PRCODI}           
                    type="text"
                    name="codigo"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                    
                  </div>
                  <div className="w-2/3 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción
                  </label>
                  <textarea                       
                    defaultValue={dataUnProcedimientoNoOperacional.PrNomb}   
                    disabled={true}          
                    type="text"
                    name="descripcion"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />                  
                  </div>                  
              </div>

              <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                     Codigo de impuesto
                    </label>
                    <input                             
                      defaultValue={dataUnProcedimientoNoOperacional.IMPCOD}               
                      disabled={true}                  
                      type="text"
                      name="centroCosto"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Descripción de impuesto
                    </label>
                    <input       
                      disabled={true}
                      defaultValue={dataUnProcedimientoNoOperacional.impDsc}          
                      type="text"
                      name="cedula"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Centro costo codigo
                    </label>
                    <input                            
                      defaultValue={dataUnProcedimientoNoOperacional.CNCCOD}          
                      disabled={true} 
                      type="text"
                      name="centroCosto"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      readOnly
                    />
                    
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Centro costo
                    </label>
                    <input       
                      disabled={true}
                      defaultValue={dataUnProcedimientoNoOperacional.CnCDsc}          
                      type="text"
                      name="cedula"
                      autoComplete="off"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    </div>
                </div>
              
              <div className="flex py-2 text-left">
              <div className="w-1/2 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Estado
                  </label>
                  <select                    
                    type="text"      
                    defaultValue={dataUnProcedimientoNoOperacional.PrSta}  
                    disabled={true}           
                    name="estado"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  >                    
                        <option value="S">Activo</option>
                        <option value="N">Inactivo</option>
                  </select>
                  </div>
                
                  
                </div>               
                
                
                <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            
          </div>
                
            </form>
            
          </div>
          
        </div>
      </div>
      
      
      
      
      
    </div>
  )
}

export default ModalConsultarProcedimientosNoOperacionales